import { render, staticRenderFns } from "./ImagemAnuncio.vue?vue&type=template&id=28c185da&scoped=true"
import script from "./ImagemAnuncio.vue?vue&type=script&lang=js"
export * from "./ImagemAnuncio.vue?vue&type=script&lang=js"
import style0 from "./ImagemAnuncio.vue?vue&type=style&index=0&id=28c185da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c185da",
  null
  
)

export default component.exports